import { createSlice } from '@reduxjs/toolkit';

import { devEnv, prodEnv, stagingEnv, extensionEnv } from '@/store/settings/constants';
import type { InitialSettingsState } from '@/store/settings/types';

const initialState: InitialSettingsState = {
    ...(typeof __IN_EXTENSION__ !== 'undefined' && __IN_EXTENSION__ ? extensionEnv : devEnv),
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setDevEnv: state => {
            state.apiUrl = devEnv.apiUrl;
        },
        setStagingEnv: state => {
            state.apiUrl = stagingEnv.apiUrl;
        },
        setProdEnv: state => {
            state.apiUrl = prodEnv.apiUrl;
        },
    },
});

export const { setDevEnv, setStagingEnv, setProdEnv } = settingsSlice.actions;
export default settingsSlice.reducer;
